import { defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { getArticleInfo } from '~/utils';
export default defineComponent({
    name: 'ArticleHeaderEntries',
    props: {
        article: {
            default: () => ({}),
            type: Object,
        },
    },
    setup(props, { root }) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Article info.
         */
        const articleInfo = getArticleInfo.call(root, props.article, { shouldGetTags: false });
        const rubrics = articleInfo.rubrics.slice(0, 2);
        return {
            articleInfo,
            css,
            rubrics,
        };
    },
});
